export const SIDC_AIR_SYMBOL = '01';
export const SIDC_AIR_MISSILE_SYMBOL = '02';
export const SIDC_LAND_SYMBOL = '10';
export const SIDC_CIVILIAN_SYMBOL = '11';
export const SIDC_SURFACE_SYMBOL = '30';
export const SIDC_SUBSURFACE_SYMBOL = '35';
export const SIDC_MINE_SYMBOL = '36';
